import React from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import AppBar from "../../Components/AppBar";
import ShoppingCartContent from "../../../Components/ShoppingCartContent";
import ShoppinCartPromotedProducts from "../../../Components/ShoppinCartPromotedProducts";

export default () => {
  return (
    <MobilePage requireUser={true}>
      <AppBar disableBottomMargin={true} />
      <PageHeader>
        <Trans>Shopping cart</Trans>
      </PageHeader>
      <ShoppingCartContent />
      <ShoppinCartPromotedProducts />
    </MobilePage>
  );
};
